import React, { useEffect, useRef } from 'react';
import './Rsvp.css';
export default function RSVPButton({ onClick,label="RSVP",style={} }) {
  const btnRef = useRef(null);
  const [glowActive, setGlowActive] = React.useState(false);

  useEffect(() => {
    function setGlowEffectRx() {
      const glowEffects = document.querySelectorAll(".glow-effect");
      glowEffects.forEach((glowEffect) => {
        const glowLines = glowEffect.querySelectorAll("rect");
        const rx = getComputedStyle(glowEffect).borderRadius;
        glowLines.forEach((line) => {
          line.setAttribute("rx", rx);
        });
      });
    }
    setGlowEffectRx();
  }, []);

  useEffect(() => {
    let timeout;
    function triggerGlow() {
      setGlowActive(true);
      timeout = setTimeout(() => {
        setGlowActive(false);
        // Randomly trigger again between 1.5s and 4s
        timeout = setTimeout(triggerGlow, Math.random() * 2500 + 1500);
      }, 1200); // match --animation-speed
    }
    triggerGlow();
    return () => clearTimeout(timeout);
  }, []);

  return (
    <button
      ref={btnRef}
      className={`rsvp-button glow-effect${glowActive ? ' glow-active' : ''}`}
      onClick={() =>{ onClick && onClick(true); }}
      data-glow-animation={glowActive ? 'true' : 'false'}
   type='submit'
   style={style}
    >
      {label}
      <svg className="glow-container">
        <rect pathLength="100" strokeLinecap="round" className="glow-blur"></rect>
        <rect pathLength="100" strokeLinecap="round" className="glow-line"></rect>
      </svg>
    </button>
  );
}
